import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { apiActionResult } from '../../common';
import { authTokenSelector } from '../../session';
import actions, { apiActions } from './actions';

export const saveType = {
  Add: 'add',
  Update: 'update'
}

export function* getEvents(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.publishedEvent.get(authToken, action.payload.skip, action.payload && action.payload.query));
}

export const savePublishedEvent = (actionType) => function* (action) {
  const { publishedEvent, nextRoute, publishedEventId } = action.payload;
  const authToken = yield select(authTokenSelector);
  const event = publishedEvent.publishedEvent
  var publishedEventFormData = {
    data: {
      publishedEvent: {
        ...event,
        dateTimeOfEvent: event.eventStartTime,
        durationDay: parseInt(event.durationDay, 10),
        durationMinute: parseInt(event.durationMinute, 10) + parseInt(event.durationHour, 10) * 60,
        price: parseFloat(event.price),
      },
      tags: publishedEvent.tags,
      aoaCpdPoints: fp.map((aoaCpdPoint) => [parseInt(aoaCpdPoint.cpdCategoryId, 10), parseFloat(aoaCpdPoint.points, 10)])(publishedEvent.aoaCpdPoints),
      goals: publishedEvent.goals
    },
    file: publishedEvent.previewImageFile
  };

  var apiAction

  switch (actionType) {
    case saveType.Add:
      apiAction = "addPublishedEvent"
      yield put(fp.get(apiAction, apiActions.publisherPortal.publishedEvent)(authToken, publishedEventFormData));
      break;
    case saveType.Update:
      apiAction = "updatePublishedEvent"
      yield put(fp.get(apiAction, apiActions.publisherPortal.publishedEvent)(authToken, publishedEventFormData, publishedEventId));
      break;
    default:
      break;
  }

  const { success } = yield apiActionResult(fp.get(apiAction, actions.publisherPortal.publishedEvent.api));

  if (success && nextRoute) {
    yield put(push(nextRoute));
  }
}

export function* getPublishedEventById(action) {
  const { publishedEventId } = action.payload;
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.publishedEvent.getPublishedEventById(authToken, publishedEventId));
}

export function* deleteEvent(action) {
  const authToken = yield select(authTokenSelector);
  const { eventId, eventQuery, nextRoute } = action.payload;

  yield put(apiActions.publisherPortal.publishedEvent.deleteEvent(authToken, eventId));

  const { success } = yield apiActionResult(actions.publisherPortal.publishedEvent.api.deleteEvent);

  if (success) {
    if (eventQuery) {
      yield put(actions.publisherPortal.publishedEvent.get(0, eventQuery));
    }
    if (nextRoute) {
      yield put(push({ pathname: nextRoute }));
    }
  }
}

export function* loadMoreEvents(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.publishedEvent.loadMore(authToken, action.payload.skip, action.payload.query));
}

export const sagas = all([
  takeLatest(actions.publisherPortal.publishedEvent.get().type, getEvents),
  takeLatest(actions.publisherPortal.publishedEvent.loadMore().type, loadMoreEvents),
  takeLatest(actions.publisherPortal.publishedEvent.savePublishedEvent().type, savePublishedEvent(saveType.Add)),
  takeLatest(actions.publisherPortal.publishedEvent.updatePublishedEvent().type, savePublishedEvent(saveType.Update)),
  takeLatest(actions.publisherPortal.publishedEvent.getPublishedEventById().type, getPublishedEventById),
  takeLatest(actions.publisherPortal.publishedEvent.deleteEvent().type, deleteEvent)
]);

function* publishedEventSagas() {
  yield sagas;
}

export default publishedEventSagas;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/published-event/sagas.js